import { Injectable } from '@angular/core';
import { LoggerService } from '@fantaz/shared/utils/log';
import { select, Store } from '@ngrx/store';

import * as ProfileActions from './profile.actions';
import * as ProfileSelectors from './profile.selectors';
import { Profile } from '@fantaz/shared/data-access/models';

@Injectable()
export class ProfileFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(ProfileSelectors.getProfileLoaded));
  profile$ = this.store.pipe(select(ProfileSelectors.getProfile));
  profileSettings$ = this.store.pipe(
    select(ProfileSelectors.getProfileSettings),
  );
  validShippingAddress$ = this.store.pipe(
    select(ProfileSelectors.isValidShippingAddress),
  );

  updating$ = this.store.pipe(select(ProfileSelectors.isUpdating));
  formErrors$ = this.store.pipe(select(ProfileSelectors.getFormErrors));

  constructor(
    private readonly store: Store,
    private readonly logger: LoggerService,
  ) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init() {
    this.logger.log('ProfileFacade.init()');
    this.store.dispatch(ProfileActions.loadProfile());
  }

  /**
   * Use the update action to perform one
   */
  updateProfileSettings(
    payload: Partial<Profile>,
    options?: { silent: boolean; msg?: string },
  ): void {
    this.logger.log('ProfileFacade.updateProfile()', payload);
    this.store.dispatch(ProfileActions.update({ payload, options }));
  }
}
